import { Modal } from '@material-ui/core'

type SubscriptionListModalProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default function SubscriptionListModal({
  open,
  setOpen
}: SubscriptionListModalProps) {
  const handleCloseModal = () => {
    setOpen(false)
  }

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <div>4</div>
    </Modal>
  )
}
